import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const Types = {
  'top-right': {
    alignment: 'column-reverse',
    textAlign: 'right'
  },
  'top-left': {
    alignment: 'column-reverse',
    textAlign: 'left'
  },
  'bottom-right': {
    alignment: 'column',
    textAlign: 'right'
  },
  'bottom-left': {
    alignment: 'column',
    textAlign: 'left'
  }
};
const Sizes = ['small', 'regular'];
const StyledLabelDataPair = styled.View`
  flex-direction: ${_ref => {
  let {
    type
  } = _ref;
  return Types[type].alignment;
}};
  align-self: flex-start;
`;
const StyledTextContainer = styled(Text.BodyExtraSmall)`
  ${_ref2 => {
  let {
    truncated
  } = _ref2;
  return truncated && `
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `;
}}
`;
export default function LabelDataPair(props) {
  const type = Object.keys(Types).includes(props.type) ? props.type : LabelDataPair.defaultProps.type;
  const size = Sizes.includes(props.size) ? props.size : LabelDataPair.defaultProps.size;
  const TextComponent = size === 'small' ? Text.BodySmall : Text.BodyBase;
  return /*#__PURE__*/React.createElement(StyledLabelDataPair, {
    type: type
  }, /*#__PURE__*/React.createElement(StyledTextContainer, {
    align: Types[type].textAlign,
    weight: "regular",
    color: Colors.gray300,
    truncated: props.truncated
  }, props.label), /*#__PURE__*/React.createElement(Spacer, {
    size: "f2",
    height: true
  }), /*#__PURE__*/React.createElement(TextComponent, {
    align: Types[type].textAlign,
    weight: "medium",
    color: Colors.gray600
  }, props.children));
}
LabelDataPair.defaultProps = {
  type: 'top-left',
  size: 'regular',
  label: 'Label',
  children: '',
  truncated: false
};
LabelDataPair.propTypes = {
  type: PropTypes.oneOf(Object.keys(Types)),
  size: PropTypes.oneOf(Sizes),
  label: PropTypes.string,
  children: PropTypes.string,
  truncated: PropTypes.bool
};
//# sourceMappingURL=index.js.map